"use client";

import { Card, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import "../../styles/CustomCollapsableCard.css";

const CustomCollapsableCard = ({ expanded, title, pageHeader, onToggle, children }) => {
  return (
    <Card
      className={`custom-collapsable-card ${expanded ? "expanded" : "collapsed"}`}
      variant="borderless"
      styles={{
        body: { padding: 0 },
      }}
      title={
        <div className="collapsible-card-header" onClick={onToggle}>
          <Space>
            {/* <CheckCircleFilled className="success-icon" /> */}
            <span className="card-title">{title}</span>
          </Space>
          <DownOutlined className={`arrow-icon ${expanded ? "rotate" : ""}`} />
        </div>
      }
    >
      {pageHeader && <h5 className="card-subtitle">{pageHeader}</h5>}
      {expanded && <div className="card-content">{children}</div>}
    </Card>
  );
};

export default CustomCollapsableCard;
